export default class Honor {
  public id!: string;
  public name !: string;
  public year !: number;
}